import { AuthToken } from "../../models/auth/auth-token.model";

export interface IAuthenticationState {
    authToken: AuthToken | null;
    isAuthenticated: boolean;
    loading: boolean;
    error: string | null;
}

export const initialAuthenticationState: IAuthenticationState = {
    authToken: null,
    isAuthenticated: false,
    loading: false,
    error: null
}